import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { forwardRef, memo } from 'react';
import styles from './styles.module.scss';
export const CsatPreview = memo(forwardRef((props, ref) => {
    return (_jsx("iframe", { ref: ref, src: "https://messenger.dixa.io/csat-preview.html", frameBorder: "0", className: classNames(styles.root, props.className), onLoad: props.onLoad }));
}));
CsatPreview.displayName = 'CsatPreview';
